import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

function dm_reveal() {

    gsap.registerPlugin(ScrollTrigger);
    reset_scroll_triggers();

    const body = document.querySelector('body');
    const header = document.querySelector('header');

    let lastScroll = 0;
    const headerHeight = header.offsetHeight;

    // HEADER
    if (header && body.classList.contains('nav-sticky-on')) {
        ScrollTrigger.create({
            start: "top top+1",
            onUpdate: (self) => {
                const currentScroll = self.scroll();
                if (currentScroll === 0) {
                    body.classList.add('scrolled-top');
                    header.classList.remove('scrolling-up');
                } else {

                    body.classList.remove('scrolled-top');
                    if (currentScroll < lastScroll ) {
                        header.classList.add('scrolling-up');
                    } else {
                        header.classList.remove('scrolling-up');
                    }
                }
                lastScroll = currentScroll;
            }
        });
        ScrollTrigger.create({
            trigger: header,
            start: "top top+1",
            end: "+=1",
            onEnter: () => header.classList.add('is-sticky'),
            onLeaveBack: () => header.classList.remove('is-sticky'),
        });
    }

    // HASH
    if (window.location.hash) {
        let $hash = window.location.hash.replace(/#/, '');
        let $target = $('section[data-slug="' + $hash + '"]');
        if ($target.length) {
            $('html,body').animate({
                scrollTop: $target.offset().top
            }, 750, 'easeOutQuad');
        }
    }

    // HASH CLICKS
    $('section a').on('click', function(e) {
        var $link = $(this).attr('href');
        if ($link && $link.includes('#') && $(this).hasClass('no-hash-scroll') === false ) {
            var tempLink = document.createElement('a');
            tempLink.href = $link;
            if (tempLink.pathname === window.location.pathname && tempLink.hostname === window.location.hostname) {
                var $hash = $link.substring($link.indexOf('#') + 1);
                let $target = $('section[data-slug="' + $hash + '"]');
                if ( $target.length ) {
                    $('html,body').animate({ scrollTop: $target.offset().top - 50 }, 0, 'linear');
                }
            }
        }
    });

    function animateFrom(elem, direction, spin) {
        if (elem.closest('.no-scroll-reveal') || elem.classList.contains('scroll-reveal-done')) return;

        direction = direction || 1;
        let x = 0,
            y = direction * 100,
            rotate = spin ? direction * 7 : 0;

        elem.style.transform = "translate(" + x + "px, " + y + "px) ";
        elem.style.opacity = "0";
        elem.style.transform = "scale(0.75) scale(0.3)" ;

        gsap.fromTo(elem, {x: x, y: y, autoAlpha: 0,transform:"scale(0.75) scale(0.3)"}, {
            duration: 1.25,
            x: 0,
            y: 0,
            autoAlpha: 1,
            transform: "scale(1) scale(1)",
            ease: "expo",
            overwrite: "auto"
        });

        elem.classList.add("scroll-reveal-done");

    }

    function hide(elem) {
        gsap.set(elem, {autoAlpha: 0});
    }

    function reset_scroll_triggers(){
        console.log(">> reset_scroll_triggers ")
        $(window).trigger('resize');
        ScrollTrigger.killAll();
        ScrollTrigger.refresh();
    }

    const parentHasNoScrollReveal = (el) => {
        if (!el || !el.classList) return false;
        if (el.classList.contains('no-scroll-reveal')) return true;

        const parentNode = el.parentNode;
        if (!parentNode) return false;

        return parentHasNoScrollReveal(parentNode);
    }

    gsap.utils.toArray($('section').find("h1,h2,h3,h4,h5,h6,p,li,a,button,img,video,table,.reveal")).forEach(function(elem, i) {
        if (
            $(elem).closest('div').hasClass('slick-slider') ||
            parentHasNoScrollReveal(elem)
        ) {
            return;
        }

        $(elem).css('transition', 'none');

        hide(elem); // assure that the element is hidden when scrolled into view

        let spin = true;
        if ( $(elem).get(0).tagName == 'IMG' || $(elem).get(0).tagName == 'VIDEO' || $(elem).get(0).tagName == 'SVG' ){
            spin = false;
        }

        ScrollTrigger.create({
            trigger: elem,
            onEnter: function() { animateFrom(elem, 1, spin) },
            onEnterBack: function() { animateFrom(elem, -1, spin) },
            onLeave: function() { /*hide(elem)*/ },
            overwrite: "all"
        });

    });

};

export { dm_reveal };
